import Cookies from 'js-cookie'

const localeApp = {
  state: {
    locale: Cookies.get('locale') || 'zh'
  },
  mutations: {
    setLocale: (state, locale) => {
      state.locale = locale
      Cookies.set('locale', locale)
    }
  },
  getters: {
    locale: state => state.locale
  },
  actions: {
    setLocale ({ commit }, locale) {
      commit('setLocale', locale)
    }
  }
}

export default localeApp



// WEBPACK FOOTER //
// ./src/store/modules/locale.js